import { BackToCartButton } from "@checkout-v2/shared/components/BackToCartButton";

import styles from "./PaymentSummaryViewHeading.module.scss";

type PaymentSummaryViewHeadingProps = {
  title?: string;
  showBackToCartButton?: boolean;
};

export const PaymentSummaryViewHeading = ({ title, showBackToCartButton = false }: PaymentSummaryViewHeadingProps) => {
  return (
    <div className={styles.container}>
      {title && <h2 className={styles.title}>{title}</h2>}

      {showBackToCartButton && <BackToCartButton variant="paymentDetails" />}
    </div>
  );
};
